import React from "react";
import "./coursecard.scss";

export default function CourseCard(props){

  return(
    <div className="courseCard">
       <div className="top-right">
        <img src="/assets/personsIcon.png" alt=".."  className="top-right-img" />
         {props.endImage}
       </div>
       <img src={props.image}  className="mainCourseCardImg" / >
       <div className="smallHeading">{props.smallHeading}</div>
       <div className="CCHeading">{props.CCHeading}</div>
       <div className="bottom-content">
        <ul className="list">
        <li>{props.line1}</li>
        <li>{props.line2}</li>
        <li>{props.line3}</li>
        <li>{props.line4}</li>
        </ul>
       </div>
       <button className="Coursebutton">Start Course</button>
    </div>
  )
}
